// Function to calculate the best text color (black or white) based on background
export const getContrastTextColor = (backgroundColor: string): string => {
  // Convert hex to RGB
  const hex = backgroundColor.replace('#', '')
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Return black for light backgrounds, white for dark backgrounds
  return luminance > 0.5 ? '#000000' : '#ffffff'
}

// Text color for a label on a white background: the color itself, or black if it is too light
export const getTextColorOnWhite = (color: string): string =>
  getContrastTextColor(color) === '#000000' ? '#000000' : color
